// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__3VZoc","round_corners":"button_round_corners__H-S8P"};